/* eslint import/no-extraneous-dependencies: 0 */
import { t } from '@lingui/macro';
import { round } from 'lodash';

import { COLUMN_TYPES } from '../../../data-table/DataTableColumns';
import { FORMATTER_TYPES } from '../../../../utilities/FormattingUtilities';
import { isShowWireless } from './WirelessInterfaceColumn';

function isWirelessTest(test) {
    const testType = test?.typeNode;
    return isWifiMultiTestChild(test) || (isShowWireless(testType) && test?.adapterType !== 'default');
}

function isWifiMultiTestChild(test) {
    return test?.adapterType === 'multi';
}

export function getWifiSearchFields(test) {
    return isWirelessTest(test) ? ['wifi_ssid', 'wifi_bssid', 'wifi_ip_address', 'wifi_connection_errors'] : [];
}

export function getWiFiColumns(test) {
    if (!isWirelessTest(test) && !isWifiMultiTestChild(test)) return [];
    const testType = test?.typeNode;
    const wifiErrors = !testType?.wifiConnectTest
        ? [
              {
                  type: COLUMN_TYPES.TEXT,
                  title: t`Wi-Fi Errors`,
                  width: 170,
                  sortable: true,
                  tooltip: false,
                  mapping: 'wifi_connection_errors',
              },
          ]
        : [];

    return [
        {
            type: COLUMN_TYPES.TEXT,
            title: t`Wi-Fi Network`,
            width: 170,
            sortable: true,
            tooltip: false,
            mapping: 'wifi_ssid',
        },
        {
            type: COLUMN_TYPES.TEXT,
            title: t`Wi-Fi BSSID`,
            width: 170,
            sortable: true,
            tooltip: false,
            mapping: 'wifi_bssid',
        },
        {
            type: COLUMN_TYPES.TEXT,
            title: t`Wi-Fi IP`,
            width: 120,
            sortable: true,
            tooltip: false,
            mapping: 'wifi_ip_address',
        },
        {
            type: COLUMN_TYPES.NUMERIC,
            title: t`Signal Strength (dBm)`,
            width: 180,
            tooltip: false,
            mapping: 'wifi_signal_level_dbm',
            sortable: true,
        },
        {
            type: COLUMN_TYPES.NUMERIC,
            title: t`Wi-Fi Channel`,
            width: 170,
            mapping: 'wifi_channel',
            tooltip: false,
            sortable: true,
        },
        {
            type: COLUMN_TYPES.NUMERIC,
            title: t`Wi-Fi Channel Frequency`,
            width: 220,
            mapping: 'wifi_frequency',
            tooltip: false,
            sortable: true,
            formatter: (value, _row, csvConfig) => {
                if (csvConfig?.displayUnits === false) return String(round(value, 3));
                return `${round(value, 3)}GHz`;
            },
            csvFormatter: { type: FORMATTER_TYPES.DECIMAL, baseUnits: 'GHz', maxDecimals: 3 },
        },
        ...wifiErrors,
    ];
}

export function getWiFiGroupTestColumn(test) {
    const filterId = 'Test';
    if (isWifiMultiTestChild(test)) {
        return [
            {
                type: COLUMN_TYPES.LINK,
                title: t`Wi-Fi Group Test`,
                width: 170,
                sortable: true,
                tooltip: false,
                mapping: 'wifi_group_test',
                link: {
                    target: `test-log`,
                    mappedTargetParams: {
                        [filterId]: 'wifi_group_test_id',
                    },
                },
            },
        ];
    }
    return [];
}
